import { useMutation, useQueryClient } from '@tanstack/react-query';
import { profileKeys } from '@/entities/profile/model/api/hooks';
import { startImpersonation, stopImpersonation } from './api';
import { authService } from './index';
import type { ImpersonationResponse, LoginRequest, LoginResponse } from './types';

export const useLogin = () => {
  const queryClient = useQueryClient();

  return useMutation<LoginResponse, unknown, LoginRequest>({
    mutationFn: authService.login,
    onSuccess: () => {
      // Invalidate and refetch the current user profile after successful login
      queryClient.invalidateQueries({ queryKey: profileKeys.me() });
    },
  });
};

/**
 * Мутация начала работы от имени другого пользователя.
 * Кэш сбрасывается целиком: сессия стала сессией другого пользователя, и всё
 * загруженное до переключения ему недоступно.
 */
export const useStartImpersonation = () => {
  const queryClient = useQueryClient();

  return useMutation<ImpersonationResponse, unknown, number>({
    mutationFn: startImpersonation,
    onSuccess: () => {
      queryClient.clear();
    },
  });
};

/**
 * Мутация возврата в собственную учётную запись.
 * Кэш сбрасывается целиком по той же причине, что и при входе в режим.
 */
export const useStopImpersonation = () => {
  const queryClient = useQueryClient();

  return useMutation<ImpersonationResponse, unknown, void>({
    mutationFn: stopImpersonation,
    onSuccess: () => {
      queryClient.clear();
    },
  });
};
